// @ts-nocheck
export enum MouseButton {
    Left = 0,
    Right = 2,
}
